import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import { useSelector } from 'react-redux';

import { currentUserLookupIdSelector } from 'redux/selectors';
import {
  fnPhoneNumberFormatterE164,
  fnPrettyFormatPhoneNumberForRegion,
} from 'utils/common';
import { SubmitButton } from 'components/Form/Buttons';
import useActions from '../../../../utils/hooks/useActions';
import * as actions from '../../../MyProfile/redux/actions';

import emailActivationSchema from './schemas';
import AlumniGoogleAccountFormBody from './AlumniGoogleAccountFormBody';

const oInitialFormValues = {
  username: '',
  password: '',
  recoveryEmail: '',
  recoveryPhoneCountry: {
    DESCRIPTION: 'United States',
    ID: '70FA9361-547E-4C98-A3CF-F655D36F8ECF',
    TYPE: 'COUNTRY',
    DETAILS: {
      ABBRV: 'US',
      NAME_ABBRV: 'US - United States',
    },
  },
  recoveryPhoneNumber: '',
};

const AlumniGoogleAccountActivationForm = () => {
  const profileActions = useActions(actions);
  const [isSuccessState, setIsSuccessState] = useState(false);
  const oProfile = useSelector((state) => state.Profile);
  const sBannerId = oProfile.BIOGRAPHICAL.BANNERID || '';
  const sLookupId = useSelector(currentUserLookupIdSelector);

  const handleFormSubmit = async (formData, formActions) => {
    const sE164FormattedRecoveryPhoneNumber = fnPhoneNumberFormatterE164(
      formData.recoveryPhoneNumber,
      formData.recoveryPhoneCountry.DETAILS.ABBRV
    );
    const sPrettyRecoveryPhoneNumber = fnPrettyFormatPhoneNumberForRegion(
      formData.recoveryPhoneNumber,
      formData.recoveryPhoneCountry.DETAILS.ABBRV
    );

    const oData = {
      firstname: oProfile.BIOGRAPHICAL.FIRSTNAME,
      lastname: oProfile.BIOGRAPHICAL.LASTNAME,
      password: formData.password,
      email: `${formData.username}@alumni.wfu.edu`,
      recoveryEmail: formData.recoveryEmail,
      recoveryPhone: {
        sRecoveryPhoneNumber: sPrettyRecoveryPhoneNumber,
        sE164FormattedRecoveryPhoneNumber,
        sPhoneCountry: formData.recoveryPhoneCountry.DETAILS.ABBRV,
      },
      bannerId: sBannerId,
    };
    const oResponse = await new Promise((resolve, reject) => {
      profileActions.signUp({
        data: oData,
        resolve,
        reject,
      });
    });
    formActions.setSubmitting(false);
    if (oResponse === 'Success') {
      await new Promise((resolve, reject) => {
        profileActions.get({
          data: {
            lookupId: sLookupId,
          },
          resolve,
          reject,
        });
      });
      setIsSuccessState(true);
    }
  };

  return isSuccessState ? (
    <div className='emailActivation__formIntro'>
      <h3 className='emailActivation__formTitle'>Woohoo! You&apos;re in!</h3>
      <p className='emailActivation__formDescrip'>
        You can now access Wake Network any time with your alumni username and
        password.
      </p>
    </div>
  ) : (
    <div className='emailActivation__form'>
      <Formik
        initialValues={oInitialFormValues}
        validationSchema={emailActivationSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleFormSubmit}
      >
        {() => (
          <Form>
            <div className='emailActivation__formIntro'>
              <p className='emailActivation__formDescrip'>
                Create your own alumni username and password here! Your username
                will become the prefix to your new alumni Gmail account (i.e.
                jane.smith@alumni.wfu.edu). If you forget your username and/or
                password in the future, it will be sent to your recovery email.
              </p>
            </div>
            <AlumniGoogleAccountFormBody />
            <SubmitButton>Activate my Alumni Gmail</SubmitButton>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AlumniGoogleAccountActivationForm;
